/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, $GraphicsBox} from '@gongxigames/framework/core/fragments/BuilderY';
import {Store, Signal} from '@gongxigames/framework/core';
import {slotStore} from '@gongxigames/framework/slotV2/globals';

type Props = {
    show: Signal<boolean>
};

export const $DebugGameSize: FC<Props> = (props) => {
    const safeZoneGame = slotStore.stage_safeZoneState_game;
    const szGameContentWidth = Store.computed(() => safeZoneGame.value.options.contentSize.width)    //         stage_safeZoneState_game.options.frame.width,
    const szGameContentHeight = Store.computed(() => safeZoneGame.value.options.contentSize.height)    //         stage_safeZoneState_game.options.frame.height

    return <$GraphicsBox
        layer='TOP'
        name='DebugGameSize'
        boxWidth={szGameContentWidth}
        boxHeight={szGameContentHeight}
        boxColor={0x00ffff}
        boxAlpha={0.2}
        boxOutlineColor={0x00ffff}
        boxOutlineAlignment={0}
        boxOutlineWidth={1}
        boxOutlineAlpha={1}
        visible={props.show}
    />;
};
